import { Box, CircularProgress, Typography } from '@mui/material'
import { InfoIcon } from '../../Svgs'
import { getEnergyEfficiencyTextColor } from '../../../utils/Common'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'
import TakeOffTooltip from '../TakeOffTooltip'
import { Can } from '../../../utils/AbilityUtil'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../../models/AccessControl'

const tooltipText = `All pricing displayed is for general informational purposes only and may not reflect final costs, as actual charges vary based on specific circumstances.`

const SpacialDesignScore = () => {
  const takeOffCalculations = useSelector(
    (state: RootState) => state.takeOff.takeOffCalculations,
  )
  const isTakeOffCalculationInProgress = useSelector(
    (state: RootState) => state.takeOff.isTakeOffCalculationInProgress,
  )

  return (
    <Box
      sx={{
        gap: '4px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '200px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '4px',
          alignItems: 'baseline',
          paddingLeft: '12px',
        }}
      >
        <Typography
          sx={{
            color: '#06004A',

            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          Spacial Design Score
        </Typography>

        <TakeOffTooltip title={tooltipText}>
          <InfoIcon sx={{ color: '#04002E', fontSize: 12 }} />
        </TakeOffTooltip>
      </Box>

      <Box
        sx={{
          gap: '10px',
          height: '100%',
          padding: '12px',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '0px 4px 4px 0px',
          backgroundColor: '#F2F2F2',
        }}
      >
        <Can I={AttributeActionNames.Read} a={AttributeResourceNames.TakeOff}>
          {!isTakeOffCalculationInProgress ? (
            <>
              <Box
                sx={{
                  padding: '12px',
                  display: 'flex',
                  flex: '1 1 0',
                  borderRadius: '4px',
                  flexDirection: 'column',
                  backgroundColor: 'white',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  sx={{
                    color: '#04002E',

                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: 'normal',
                  }}
                >
                  Energy Efficiency
                </Typography>

                <Typography
                  sx={{
                    fontSize: '46px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: 'normal',
                    color: takeOffCalculations?.energyEfficiency
                      ? getEnergyEfficiencyTextColor(
                          takeOffCalculations.energyEfficiency,
                        )
                      : '#04002E',
                  }}
                >
                  {takeOffCalculations?.energyEfficiency
                    ? `${takeOffCalculations.energyEfficiency}%`
                    : 'N/A'}
                </Typography>
              </Box>

              <Box
                sx={{
                  padding: '12px',
                  display: 'flex',
                  flex: '1 1 0',
                  borderRadius: '4px',
                  flexDirection: 'column',
                  backgroundColor: 'white',
                }}
              >
                <Typography
                  sx={{
                    color: '#04002E',

                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: 'normal',
                  }}
                >
                  Validation Optimization
                </Typography>

                <Typography
                  sx={{
                    fontSize: '46px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: 'normal',
                    justifyContent: 'space-between',
                    color: takeOffCalculations?.validationOptimization
                      ? '#1705E5'
                      : '#04002E',
                  }}
                >
                  {takeOffCalculations?.validationOptimization
                    ? `${takeOffCalculations.validationOptimization}%`
                    : 'N/A'}
                </Typography>
              </Box>
            </>
          ) : (
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Can>
      </Box>
    </Box>
  )
}

export default SpacialDesignScore
